import { render, staticRenderFns } from "./Good.vue?vue&type=template&id=9c32ffc2&scoped=true&"
import script from "./Good.vue?vue&type=script&lang=ts&"
export * from "./Good.vue?vue&type=script&lang=ts&"
import style0 from "./Good.vue?vue&type=style&index=0&id=9c32ffc2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-93e13427ca/0/cache/vue-loader-npm-15.9.8-438f4d0ff0-ca4c99b261.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c32ffc2",
  null
  
)

export default component.exports